import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { PgSendMessageModalComponent } from './pg-send-message-modal/pg-send-message-modal.component';
import { PgUiControlsModule } from '../pg-ui-controls/pg-ui-controls.module';
import { PgUiElementsModule } from '../pg-ui-elements/pg-ui-elements.module';
import { PgLoginHandlerComponent } from './pg-login-handler/pg-login-handler.component';
import { PgSlugEditorComponent } from './pg-slug-editor/pg-slug-editor.component';
import { PgHeaderComponent } from './pg-header/pg-header.component';
import { PgCodeCheckerComponent } from './pg-code-checker/pg-code-checker.component';
import { PgUserWidgetComponent } from './pg-user-widget/pg-user-widget.component';
import { PgWeatherComponent } from './pg-weather/pg-weather.component';

import { PgUserMenuComponent } from './pg-user-menu/pg-user-menu.component';
import { PgCalendarAvailabilityComponent } from './pg-calendar/pg-calendar-availability.component';
import { PgCalendarResourceComponent } from './pg-calendar/pg-calendar-resource.component';
import { PgCalendarSelectComponent } from './pg-calendar/pg-calendar-select.component';
import { PgUserPickerComponent } from './pg-user-picker/pg-user-picker.component';
import { PgResourceAssociationComponent } from './pg-resource-association/pg-resource-association.component';
import { PgGroupPickerComponent } from './pg-group-picker/pg-group-picker.component';
import { PgGroupWidgetComponent } from './pg-group-widget/pg-group-widget.component';
import { PgAdminGroupsComponent } from './pg-admin-groups/pg-admin-groups.component';
import { PgAdminUsersComponent } from './pg-admin-users/pg-admin-users.component';
import { PgHelpModule } from '../pg-help/pg-help.module';
import { PgTasksViewComponent } from './pg-tasks-view/pg-tasks-view.component';
import { PgFooterComponent } from './pg-footer/pg-footer.component';
import { PgAvailabilitySelectComponent } from './pg-availability-select/pg-availability-select.component';
import { PgChatModule } from '../pg-chat/pg-chat.module';
import { PgPriorityPickerComponent } from './pg-priority-picker/pg-priority-picker.component';
import { PgCustomerCareSettingsComponent } from './pg-customer-care-settings/pg-customer-care-settings.component';
import { PgAdminRealmUsersComponent } from './pg-admin-realm-users/pg-admin-realm-users.component';
import { PgRealmPickerComponent } from './pg-realm-picker/pg-realm-picker.component';
import { PgRealmInviteComponent } from './pg-realm-invite/pg-realm-invite.component';
import { PgAcceptConditionsComponent } from './pg-accept-conditions/pg-accept-conditions.component';
import { PgResourceElementMenuComponent } from './pg-resource-element-menu/pg-resource-element-menu.component';
import { PgTagPickerComponent } from './pg-tag-picker/pg-tag-picker.component';
import { PgSelectPickerComponent } from './pg-select-picker/pg-select-picker.component';
import { PGFilterEditorSearch } from './pg-filter-editor-search/pg-filter-editor-search.component';
import { PgFileLicensePickerComponent } from './pg-file-license-picker/pg-file-license-picker.component';
import { PgNotificationListComponent } from './pg-notification-list/pg-notification-list.component';
import { PgManageNotificationsComponent } from './pg-manage-notifications/pg-manage-notifications.component';
import { PgSaveStatusComponent } from './pg-save-status/pg-save-status.component';
import { PgChangePasswordComponent } from './pg-change-password/pg-change-password.component';
import { PgProfileEditorComponent } from './pg-profile-editor/pg-profile-editor.component';
import { PgEditProfileComponent } from './pg-edit-profile/pg-edit-profile.component';
import { PgMassPublishModalComponent } from './pg-mass-publish-modal/pg-mass-publish-modal.component';
import { PgLoginHandlerDefaultComponent } from './pg-login-handler/pg-login-handler-default/pg-login-handler-default.component';
import { PgLoginHandlerOtpComponent } from './pg-login-handler/pg-login-handler-otp/pg-login-handler-otp.component';
import { PgLoginHandlerCodeComponent } from './pg-login-handler/pg-login-handler-code/pg-login-handler-code.component';
import { PgCompleteProfileComponent } from './pg-complete-profile/pg-complete-profile.component';
import { PgVisitCardConfirmComponent } from './pg-visit-card-confirm/pg-visit-card-confirm.component';
import { PgSupplierDeleteConfirmComponent } from './pg-supplier-delete-confirm/pg-supplier-delete-confirm.component';

@NgModule({
    declarations: [
        PgSendMessageModalComponent,
        PgLoginHandlerComponent,
        PgLoginHandlerDefaultComponent,
        PgLoginHandlerOtpComponent,
        PgLoginHandlerCodeComponent,
        PgCompleteProfileComponent,
        PgSlugEditorComponent,
        PgHeaderComponent,
        PgCodeCheckerComponent,
        PgUserWidgetComponent,
        PgWeatherComponent,
        PgChangePasswordComponent,
        PgUserMenuComponent,
        PgCalendarAvailabilityComponent,
        PgCalendarResourceComponent,
        PgCalendarSelectComponent,
        PgUserPickerComponent,
        PgGroupPickerComponent,
        PgResourceAssociationComponent,
        PgGroupWidgetComponent,
        PgAdminGroupsComponent,
        PgAdminUsersComponent,
        PgTasksViewComponent,
        PgFooterComponent,
        PgAvailabilitySelectComponent,
        PgPriorityPickerComponent,
        PgFileLicensePickerComponent,
        PgAdminRealmUsersComponent,
        PgCustomerCareSettingsComponent,
        PgRealmPickerComponent,
        PgRealmInviteComponent,
        PgAcceptConditionsComponent,
        PgResourceElementMenuComponent,
        PgTagPickerComponent,
        PgSelectPickerComponent,
        PGFilterEditorSearch,
        PgNotificationListComponent,
        PgManageNotificationsComponent,
        PgSaveStatusComponent,
        PgProfileEditorComponent,
        PgEditProfileComponent,
        PgMassPublishModalComponent,
        PgVisitCardConfirmComponent,
        PgSupplierDeleteConfirmComponent
    ],
    imports: [
        CommonModule,
        NgbModule,
        FormsModule,
        PgUiControlsModule,
        PgUiElementsModule,
        PgHelpModule,
        PgChatModule
    ],
    exports: [
        PgSendMessageModalComponent,
        PgLoginHandlerComponent,
        PgCompleteProfileComponent,
        PgSlugEditorComponent,
        PgHeaderComponent,
        PgCodeCheckerComponent,
        PgUserWidgetComponent,
        PgGroupWidgetComponent,
        PgWeatherComponent,
        PgUserMenuComponent,
        PgCalendarAvailabilityComponent,
        PgCalendarResourceComponent,
        PgCalendarSelectComponent,
        PgUserPickerComponent,
        PgGroupPickerComponent,
        PgResourceAssociationComponent,
        PgAdminGroupsComponent,
        PgAdminUsersComponent,
        PgTasksViewComponent,
        PgFooterComponent,
        PgAvailabilitySelectComponent,
        PgPriorityPickerComponent,
        PgFileLicensePickerComponent,
        PgAdminRealmUsersComponent,
        PgCustomerCareSettingsComponent,
        PgRealmPickerComponent,
        PgRealmInviteComponent,
        PgAcceptConditionsComponent,
        PgResourceElementMenuComponent,
        PgTagPickerComponent,
        PgSelectPickerComponent,
        PGFilterEditorSearch,
        PgNotificationListComponent,
        PgManageNotificationsComponent,
        PgSaveStatusComponent,
        PgProfileEditorComponent,
        PgMassPublishModalComponent,
        PgVisitCardConfirmComponent,
        PgSupplierDeleteConfirmComponent
    ]
})
export class PgUiMoleculesModule { }
